import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Table  } from 'antd';
import Card from "components/card";
import AssignedAssetsForm from "./AssignedAssetsForm";
import PopupButton from "components/button/PopupButton";
import CrudOption from "components/dropdown/crudoption";
import { MODULE_EMPLOYEES } from "variables/constants";
import {
    getEmployeeAssignedAssetList,
	doEmployeeAssignedAssetDelete,
	doEmployeeAssignedAssetReset
} from "../../../../../redux/employeeassignedasset/employeeAssignedAssetState";
import { handleTableChange } from "../../../../../utils/index";

const AssignedAssetsTable = ({
	employeeId,
}) => {
	const dispatch = useDispatch();
	const doSearch = (filters) => dispatch(getEmployeeAssignedAssetList(filters));
	const doDelete = (recordId) => dispatch(doEmployeeAssignedAssetDelete(recordId));
	const doRecordReset = () =>  dispatch(doEmployeeAssignedAssetReset());
	
    const recordList = useSelector((state) => state.employeeAssignedAsset.employeeAssignedAsset?.items || []);
    const pagination= useSelector((state) => state.employeeAssignedAsset.employeeAssignedAsset?.pagination);
    const filters= useSelector((state) => state.employeeAssignedAsset.employeeAssignedAsset?.filters);

	const columns = [
		{
			title: 'Asset No.',
			dataIndex: 'eaa_asset_id',
			key: 'eaa_asset_id',
			width: '5%',
			render: (eaa_asset_id) => <span>{eaa_asset_id}</span>
		},
		{
			title: 'Equipment Type',
			dataIndex: 'asset_type',
			key: 'asset_type',
			width: '12%',
			render: (asset_type) => <span>{asset_type}</span>
		},
		{
			title: 'Equipment Name',
			dataIndex: 'asset_name',
			key: 'asset_name',
			width: '20%',
			render: (asset_name) => <span>{asset_name}</span>
		},
		{
			title: 'Condition',
			dataIndex: 'asset_condition_name',
			key: 'asset_condition_name',
			width: '12%',
			render: (asset_condition_name) => <span>{asset_condition_name}</span>
		},
		{
			title: 'Date Provided',
			dataIndex: 'eaa_date_provided',
			key: 'eaa_date_provided',
			width: '12%',
			render: (eaa_date_provided) => <span>{eaa_date_provided}</span>
		},
		{
			title: 'Date Returned',
			dataIndex: 'eaa_date_returned',
			key: 'eaa_date_returned',
			width: '12%',
			render: (eaa_date_returned) => <span>{eaa_date_returned || '-'}</span>
		},
		{
			title: 'Status',
    		dataIndex: 'asset_status_name',
			key: 'asset_status_name',
			width: '10%',
			render: (asset_status_name) => <span>{asset_status_name}</span>
		},
		{
			title: <PopupButton id="add_assigned_asset" title="Assign Asset" label="Add" btnClass="btn-small" action="add" moduleId={MODULE_EMPLOYEES}>
						<AssignedAssetsForm recordId={0} mode="edit" employeeId={0} />
					</PopupButton>,
			dataIndex: 'eaa_id',
			key: 'eaa_id',
			width: '12%',
			render: (_, record) => (
				<CrudOption
					recordId={record?.eaa_id}
					baseRoute={`/console/employees/${employeeId}/assigned-assets`}
					editMode="modal"
					deleteHandler={() => doDelete({
						recordId: record.eaa_id,
						eaa_id: record.eaa_id,
					})}
					title="Edit Assigned Asset"
					editHandler={(recordId, doRecordReset) => (
						<AssignedAssetsForm
							recordId={recordId}
							onCancel={doRecordReset}
							mode="edit"
						/>
					)}
					allowEdit={!record.eaa_date_returned}
					allowDelete={record.eaa_date_returned}
					closeHandler={doRecordReset}
				/>
			)
		},
	];

	useEffect(() => {
		if (!employeeId) return;

		dispatch(
			getEmployeeAssignedAssetList({
				paginate: pagination?.per_page || 10,
				eaa_employee_id: employeeId,
			})
		);
	}, [dispatch, employeeId]);
	
  	return (
	    <Card extra={"w-full h-full p-4"}>
	      	<div className="h-full overflow-x-scroll xl:overflow-x-hidden">
				<Table
					dataSource={recordList}
					columns={columns}
					rowKey={(record) => record.eaa_id}
					pagination={{
						...pagination,
						showTotal: (total, range) =>
							`${range[0]} - ${range[1]} of ${total} records`,
					}}
					onChange={handleTableChange(doSearch, filters)}
				/>
	      	</div>
	    </Card>
  );
};


export default (AssignedAssetsTable);